export { default } from "~/components/ui/BannerGrid";

export const eager = true;
export const sync = true;

export function LoadingFallback() {
  return (
    <section className="w-full mx-auto px-0">
      <div className="flex flex-col gap-4 md:grid md:grid-cols-2 md:gap-6 mt-2 lg:mt-0">
        <div className="skeleton animate-pulse w-full aspect-[4/5]" />
        <div className="skeleton animate-pulse w-full aspect-[4/5]" />
      </div>
    </section>
  );
}
